import React, {Component} from "react";
import Button from "../../../components/UI/Button/Button";
import {DataGrid, GridApi, GridCellValue, GridToolbar} from '@material-ui/data-grid';
import Snackbar from "../../../components/UI/Snackbar/Snackbar";
import Auxiliary from '../../../hoc/Auxiliary/Auxiliary';
import classes from "../Spedizioni.css";
import instance from "../../../axios-spc";
import { MaterialReactTable } from 'material-react-table';
import Box from "@mui/material/Box";
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import IMAGES from "../../../store/images";
import Modal from "../../../components/UI/Modal/Modal";
import ContenutoSpedizione from "../StoricoSpedizioni/ContenutoSpedizione/ContenutoSpedizione";
import ModalDialog from "../../../components/UI/Modal/ModalDialog";
import ednpointWeb from "../../../endpoint";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

class SpedizioniPending extends Component{


    state = {
        spedizioni: [
        ],
        pageSize: 5,
        confirm: false,
        confirmReinvio: false,
        confirmSpedizione: false,
        error: false,
        errorReinvio: false,
        expandedAccordion: false,
        anchorEl: null,
        anchorElStorico: null,
        storico: [],
        isRichiestaReinvio: false,
        isConfermaSpedizione: false,
        spedizioneDaReinviare: null,
        spedizioneDaConfermare: null
    };



    componentDidMount() {
        var postData = {
            id_negozio: localStorage.getItem("idNegozio")
        };
        instance.post('/getSpedizioniPending', postData).then(resp => {
            this.setState({spedizioni: resp.data})
        });
        if (localStorage.getItem("role") == 2) {
            this.getSpedizioniMaster()
        } else {
            this.getSpedizioni();
        }
    }

    getSpedizioni = () => {
        var postData = {
            id_negozio: localStorage.getItem("idNegozio"),
            data_inizio: null,
            data_fine: null
        };

        instance.post('/getListaSpedizioni', postData).then(resp => {
            for (let i in resp.data) {
                resp.data[i].data_richiesta_spedizione_magcent = new Date((resp.data[i].data_richiesta_spedizione_magcent));
                resp.data[i].id = resp.data[i].id_spedizione_magcent;
                let visualizza = (<img src={IMAGES.iconVedi} title={"CONTENUTO SPEDIZIONE"} style={{width: '27px', cursor: 'pointer', padding: '2px', marginRight: '5px'}} onClick={(id) => this.openModal(resp.data[i].id)} color="inherit"/>);
                let ddt = (<img src={IMAGES.iconDDT} title={"STAMPA D.D.T."} style={{width: '27px', cursor: 'pointer', padding: '2px', marginRight: '5px'}} onClick={(id) => this.openDdt(resp.data[i].id, resp.data[i].motivo_spedizione_magcent)} color="inherit"/>);
                let reinvio = (<ReplayCircleFilledIcon titleAccess={"REINVIA"} onClick={(id) => this.openModalReinvio(resp.data[i].id)} style={{width: '27px', cursor: 'pointer', padding: '2px', color:'#235884', fontSize: 'xx-large',  marginRight: '5px'}}/>)
                let reinvioDisabled = (<ReplayCircleFilledIcon titleAccess={"REINVIA"} style={{width: '27px', cursor: 'default', padding: '2px', color:'#CCCCCC', fontSize: 'xx-large',  marginRight: '5px'}}/>)
                let tracking = (<AssistantDirectionIcon titleAccess={"TRACK"} onClick={(id) => this.openGLSTracking(resp.data[i].tracking_spedizione)} style={{width: '27px', cursor: 'pointer', padding: '2px', color:'#235884', fontSize: 'xx-large',  marginRight: '5px'}}/>)
                let arrivato = (<LocalShippingIcon titleAccess={"ARRIVATO"} onClick={(id) => this.openModalConfermaSpedizione(resp.data[i].id)} style={{width: '27px', cursor: 'pointer', padding: '2px', color: '#235884', fontSize: 'xx-large',  marginRight: '5px'}}/>);
                let operations = [];
                operations.push(visualizza);
                operations.push(ddt);
                if (resp.data[i].stato === 'RICHIESTA INVIATA') operations.push(reinvioDisabled); else operations.push(reinvio);
                if (resp.data[i].stato === 'RITIRO PRESO IN CARICO') operations.push(tracking);
                if (localStorage.getItem("role") == 3 ) {
                    operations.push(arrivato)
                }
                resp.data[i].azioni = operations;
            }
            this.setState({storico: resp.data})
        });
    };

    getSpedizioniMaster = () => {
        var postData = {
            id_affiliato: localStorage.getItem("idAffiliato"),
            data_inizio: null,
            data_fine: null
        };

        instance.post('/getSpedizioniMaster', postData).then(resp => {
            for (let i in resp.data) {
                resp.data[i].data_richiesta_spedizione_magcent = new Date((resp.data[i].data_richiesta_spedizione_magcent));
                resp.data[i].id = resp.data[i].id_spedizione_magcent;
                let visualizza = (<img src={IMAGES.iconVedi} style={{width: '27px', cursor: 'pointer', padding: '2px', marginRight: '5px'}} onClick={(id) => this.openModal(resp.data[i].id)} color="inherit"/>);
                let ddt = (<img src={IMAGES.iconDDT} title={"STAMPA D.D.T."} style={{width: '27px', cursor: 'pointer', padding: '2px', marginRight: '5px'}} onClick={(id) => this.openDdt(resp.data[i].id)} color="inherit"/>);
                let operations = [];
                operations.push(visualizza);
                operations.push(ddt);
                resp.data[i].azioni = operations;
            }
            this.setState({storico: resp.data})
        });
    };

    openModal = (id) => {
        this.setState({visualizzaScheda: true, idSpedizioneDettaglio: id});
    };

    openDdt = (id, motivo) => {
        if (motivo === 'SPEDIZIONE_INTERNA')  window.open(ednpointWeb + "/stampaDdtInterno?id=" + id);
        else window.open(ednpointWeb + "/stampaDdt?id=" + id);
        // window.open("http://localhost:3000/stampaDdt?id=" + id);
    };

    openGLSTracking = (tracking) => {
        // let trackingUrl = "https://wwwdr.gls-italy.com/XML/get_xml_track.php?locpartenza=M6&numrit=" + tracking.substring(2) + "&CodCli=2397";
        window.open(tracking);
    };

    visualizzaSchedaCancelHandler = () => {
        this.setState({visualizzaScheda: false, idSpedizioneDettaglio: null})
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return ;
        }
        this.setState({confirm: false, error: false, confirmReinvio: false, errorReinvio: false, confirmSpedizione: false});
    };

    handleToogle() {
        let expanded = !this.state.expandedAccordion;
        this.setState({expandedAccordion: expanded})
    }

    openModalReinvio = (id) => {
        this.setState({isRichiestaReinvio: true, spedizioneDaReinviare: id})
    };
    openModalConfermaSpedizione = (id) => {
        this.setState({isConfermaSpedizione: true, spedizioneDaConfermare: id})
    };

    confermaSpedizione = (id) => {
        var postData = {
            id_spedizione: id,
            id_operatore: localStorage.getItem("userId")
        };
        instance.post('/setSpedizioneArrivata', postData).then(resp => {
            if (resp.data[0].ret_code === 0) {
                this.setState({ confirmSpedizione: true});
                this.ricercaCancelHandler();
                this.getSpedizioni();
            }
        });
    };

    reinviaSpedizione = (idSpedizione) => {
        var postData = {
            id_negozio: localStorage.getItem("idNegozio"),
            id_spedizione: idSpedizione,
            id_operatore: localStorage.getItem("userId")
        };
        instance.post('/setReinvioSpedizione', postData).then(resp => {
            if (resp.data[0].ret_code === 0) {
                this.setState({ confirmReinvio: true});
                this.ricercaCancelHandler();
                this.getSpedizioni();
            } else {
                this.setState({ errorReinvio: true});
                this.ricercaCancelHandler();
            }
        });
    };

    handleMenu = (event) => {
        this.setState({anchorEl: event.currentTarget})
    };
    handleMenuStorico = (event) => {
        this.setState({anchorElStorico: event.currentTarget})
    };

    handleCloseMenu = () => {
        this.setState({anchorEl: null, anchorElStorico: null})
    };
    ricercaCancelHandler = () => {
        this.setState({isRichiestaReinvio: false, spedizioneDaReinviare: null, isConfermaSpedizione: false, spedizioneDaConfermare: null})
    };

    render() {

        let schedaCompleta = null;
        if (this.state.visualizzaScheda) {
            schedaCompleta = (
                <Modal show={this.state.visualizzaScheda} modalClosed={this.visualizzaSchedaCancelHandler} title={"Spedizione " + this.state.idSpedizioneDettaglio} >
                    <ContenutoSpedizione id={this.state.idSpedizioneDettaglio} />
                </Modal>
            )
        }

        let modal = null;
        if (this.state.isRichiestaReinvio) {
            modal = (
                <ModalDialog show={this.state.isRichiestaReinvio} modalClosed={this.ricercaCancelHandler} customStyle={"Dialog"} title={"Sicuro di voler richiedere una nuova presa?"}>
                    <Button style={{margin: '2%'}} clicked={() => this.reinviaSpedizione(this.state.spedizioneDaReinviare)}>Conferma</Button>
                    <Button style={{margin: '2%', backgroundColor: '#e5e5e5', color: '#235884'}} clicked={() => this.ricercaCancelHandler()}>Annulla</Button>
                </ModalDialog>)
        }
        let modalConferma = null;
        if (this.state.isConfermaSpedizione) {
            modalConferma = (
                <ModalDialog show={this.state.isConfermaSpedizione} modalClosed={this.ricercaCancelHandler} customStyle={"Dialog"} title={"Sicuro di voler confermare tutti i devices?"}>
                    <Button style={{margin: '2%'}} clicked={() => this.confermaSpedizione(this.state.spedizioneDaConfermare)}>Conferma</Button>
                    <Button style={{margin: '2%', backgroundColor: '#e5e5e5', color: '#235884'}} clicked={() => this.ricercaCancelHandler()}>Annulla</Button>
                </ModalDialog>)
        }

        const newColumnsStorico = [
            {accessorKey: 'id', header: 'D.D.T.', editable: false},
            {accessorKey: 'data_richiesta_spedizione_magcent', header: 'Data', editable: false, Cell: ({ cell }) => cell.getValue()?.toLocaleDateString()},
            {accessorKey: 'motivo_spedizione_magcent', header: 'Motivo', editable: false},
            {accessorKey: 'tracking_spedizione', header: 'Track', editable: false},
            {accessorKey: 'numero_devices', header: 'Num. Devices', editable: false},
            {accessorKey: 'stato', header: 'Stato', editable: false},
            {accessorKey: 'azioni', header: 'Azioni'},
        ];

        const newColumnsMaster = [
            {accessorKey: 'id', header: 'D.D.T.', editable: false, size: 50},
            {accessorKey: 'data_richiesta_spedizione_magcent', header: 'Data', editable: false, Cell: ({ cell }) => cell.getValue()?.toLocaleDateString(), size: 75},
            {accessorKey: 'negozio_spedizione', header: 'Negozio', editable: false, size: 250},
            {accessorKey: 'motivo_spedizione_magcent', header: 'Motivo', editable: false},
            {accessorKey: 'tracking_spedizione', header: 'Track', editable: false},
            {accessorKey: 'numero_devices', header: 'Num. Devices', editable: false, size: 75},
            {accessorKey: 'stato', header: 'Stato', editable: false},
            {accessorKey: 'azioni', header: 'Azioni', size: 75},
        ];

        let visibleColumns = {
            tracking_spedizione: false
        };

        if (localStorage.getItem("role") == 2) {
            visibleColumns = {
                tracking_spedizione: false,
                motivo_spedizione_magcent: false
            };
        }

        let listaStoricoSpedizioni = (
            <MaterialReactTable
                columns={localStorage.getItem("role") === 2 ? newColumnsMaster : newColumnsStorico}
                data={this.state.storico}
                muiTablePaginationProps={{
                    rowsPerPageOptions: [10, 25, 50, 100]
                }}
                initialState={{ columnPinning: { right: ['azioni'] }, columnVisibility: visibleColumns, density: 'compact'  }}
                layoutMode="grid"
                renderTopToolbarCustomActions={({table}) => (
                    <Box
                        sx={{display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap'}}
                    >
                        <IconButton
                            onClick={(event) => this.handleMenuStorico(event)}
                            size="small"
                            sx={{ml: 2}}
                            aria-controls={this.state.anchorElStorico ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={this.state.anchorElStorico ? 'true' : undefined}
                        >
                            <Avatar sx={{width: 32, height: 32}}>?</Avatar>
                        </IconButton>
                        <Menu
                            anchorEl={this.state.anchorElStorico}
                            id="account-menu"
                            open={this.state.anchorElStorico}
                            onClose={() => this.handleCloseMenu()}
                            onClick={() => this.handleCloseMenu()}
                            slotProps={{
                                paper: {
                                    elevation: 0,
                                    sx: {
                                        overflow: 'visible',
                                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                        mt: 1.5,
                                        '& .MuiAvatar-root': {
                                            width: 32,
                                            height: 32,
                                            ml: -0.5,
                                            mr: 1,
                                        },
                                        '&::before': {
                                            content: '""',
                                            display: 'block',
                                            position: 'absolute',
                                            top: 0,
                                            right: 14,
                                            width: 10,
                                            height: 10,
                                            bgcolor: 'background.paper',
                                            transform: 'translateY(-50%) rotate(45deg)',
                                            zIndex: 0,
                                        },
                                    },
                                },
                            }}
                            transformOrigin={{horizontal: 'right', vertical: 'top'}}
                            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                        >
                            <MenuItem onClick={() => this.handleCloseMenu()} style={{cursor: 'default'}}>
                                <strong>Legenda</strong>
                            </MenuItem>
                            <Divider/>
                            <MenuItem onClick={() => this.handleCloseMenu()} style={{cursor: 'default'}}>
                                RICHIESTA INVIATA: il punto vendita ha inviato la richiesta di presa che deve ancora essere presa in carico da GLS
                            </MenuItem>
                            <MenuItem onClick={() => this.handleCloseMenu()} style={{cursor: 'default'}}>
                                RITIRO PRESO IN CARICO: il corriere ha preso in carico il ritiro
                            </MenuItem>
                            <MenuItem onClick={() => this.handleCloseMenu()} style={{cursor: 'default'}}>
                                <img src={IMAGES.iconVedi} style={{width: '27px', cursor: 'default', padding: '2px', marginRight: '5px'}} /> Vedi dettagli spedizione
                            </MenuItem>
                            <MenuItem onClick={() => this.handleCloseMenu()} style={{cursor: 'default'}}>
                                <img src={IMAGES.iconDDT} style={{width: '27px', cursor: 'default', padding: '2px', marginRight: '5px'}} /> Stampa lettera di vettura
                            </MenuItem>
                            <MenuItem onClick={() => this.handleCloseMenu()} style={{cursor: 'default'}}>
                                <ReplayCircleFilledIcon style={{width: '27px', cursor: 'pointer', padding: '2px', color:'#235884', fontSize: 'xx-large',  marginRight: '5px'}}/> Richiedi nuova presa (operazione possibile solo se lo stato è RITIRO PRESO IN CARICO)
                            </MenuItem>
                            <MenuItem onClick={() => this.handleCloseMenu()} style={{cursor: 'default'}}>
                                <AssistantDirectionIcon style={{width: '27px', cursor: 'pointer', padding: '2px', color:'#235884', fontSize: 'xx-large',  marginRight: '5px'}}/> Visualizza tracking GLS (operazione possibile solo se lo stato è RITIRO PRESO IN CARICO)
                            </MenuItem>
                        </Menu>
                    </Box>
                )}
            />
        );

        let confirmAlert = (
            <Snackbar open={this.state.confirm} closed={this.handleClose} style={{fontSize: 'larger'}} severity="success">Spedizione creata correttamente!</Snackbar>
        );
        let errorAlert = (
            <Snackbar vertical={'top'} horizontal={'center'} open={this.state.error} closed={this.handleClose} style={{fontSize: 'larger'}} severity="error">Non è possibile creare la spedizione con i device selezionati.</Snackbar>
        );
        let confirmReinvioAlert = (
            <Snackbar open={this.state.confirmReinvio} closed={this.handleClose} style={{fontSize: 'larger'}} severity="success">Richiesta di ritiro reinviata correttamente</Snackbar>
        );
        let confirmSpedizioneConfermata = (
            <Snackbar open={this.state.confirmSpedizione} closed={this.handleClose} style={{fontSize: 'larger'}} severity="success">Devices confermati e in stato IN LAVORAZIONE</Snackbar>
        );
        let errorReinvioAlert = (
            <Snackbar vertical={'top'} horizontal={'center'} open={this.state.errorReinvio} closed={this.handleClose} style={{fontSize: 'larger'}} severity="error">Errore nell'invio della richiesta</Snackbar>
        );

        const handleExportData = (data) => {
            let deviceDaSpedire = data.map(device => device.original);
            let spedizioneProgrammabileNumero = false;
            let spedizioneProgrammabileValore = false;
            if (data.length >= 3) {
                spedizioneProgrammabileNumero = true;
            } else {
                for (let i = 0; i < deviceDaSpedire.length && !spedizioneProgrammabileValore; ++i) {
                    spedizioneProgrammabileValore = deviceDaSpedire[i].valore_acquisto >= 300;
                }
            }

            if (spedizioneProgrammabileNumero || spedizioneProgrammabileValore) {
                var postData = {
                    numero_device: data.length,
                    id_negozio: localStorage.getItem("idNegozio")
                };
                instance.post('/setSpedizioniManuali', postData).then(resp => {
                    if (resp.data[0].ret_code === 0) {
                        deviceDaSpedire.forEach((element) => {
                            let postData = {
                                serial_number: element.serial_number,
                                num_times: element.num_times,
                                id_operatore: localStorage.getItem("userId"),
                                id_ddt: resp.data[0].id_spedizione
                            };

                            instance.post('/setSpedito', postData).then(resp => {
                                console.log(resp);
                                this.setState({confirm: true, error: false});
                                var postDataGet = {
                                    id_negozio: localStorage.getItem("idNegozio")
                                };
                                instance.post('/getSpedizioniPending', postDataGet).then(response => {
                                    this.setState({spedizioni: response.data});
                                    this.getSpedizioni();
                                });
                            });
                        })
                    }
                });
            } else {
                this.setState({confirm: false, error: true})
            }
        };

        const handleExportDataInterno = (data) => {
            let deviceDaSpedire = data.map(device => device.original);

            var postData = {
                numero_device: data.length,
                id_negozio: localStorage.getItem("idNegozio")
            };
            instance.post('/setSpedizioniManualiInterne', postData).then(resp => {
                if (resp.data[0].ret_code === 0) {
                    deviceDaSpedire.forEach((element) => {
                        let postData = {
                            serial_number: element.serial_number,
                            num_times: element.num_times,
                            id_operatore: localStorage.getItem("userId"),
                            id_ddt: resp.data[0].id_spedizione
                        };

                        instance.post('/setStatusSpeditoInterno', postData).then(resp => {
                            console.log(resp);
                            this.setState({confirm: true, error: false});
                            var postDataGet = {
                                id_negozio: localStorage.getItem("idNegozio")
                            };
                            instance.post('/getSpedizioniPending', postDataGet).then(response => {
                                this.setState({spedizioni: response.data});
                                this.getSpedizioni();
                            });
                        });
                    })
                }
            });
        };

        const newColumns = [
            {accessorKey: 'serial_number', header: 'ID', editable: false},
            {accessorKey: 'brand_name', header: 'Brand', editable: false},
            {accessorKey: 'model_name', header: 'Modello', editable: false},
            {accessorKey: 'imei', header: 'IMEI', editable: false},
            {accessorKey: 'memory_gb', header: 'Memoria', editable: false},
            {accessorKey: 'valore_acquisto', header: 'Valore Acquisto', editable: false},
        ];

        let listaSpedizioniPending = null;

        if (localStorage.getItem("role") < 2) {
            listaSpedizioniPending = (
                <Box style={{textAlign: '-webkit-center'}}>
                    <Box className={classes.ResultBox}>
                        <h3 className={classes.FiltriTitle}>
                            SPEDIZIONI IN ATTESA
                        </h3>
                        <MaterialReactTable
                            columns={newColumns}
                            data={this.state.spedizioni}
                            enableRowSelection
                            // enableColumnOrdering
                            enablePinning
                            enableGlobalFilter={true}
                            muiTablePaginationProps={{
                                rowsPerPageOptions: [10, 25, 50, 100]
                            }}
                            // onRowSelectionChange={() => setRowSelection()}
                            initialState={{density: 'compact'}}
                            layoutMode="grid"
                            renderTopToolbarCustomActions={({table}) => (
                                <Box
                                    sx={{display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap'}}
                                >
                                    <Button
                                        color="primary"
                                        clicked={() => handleExportData(table.getSelectedRowModel().rows)}
                                        variant="contained"
                                    >
                                        {'GENERA SPEDIZIONE'}
                                    </Button>
                                    <IconButton
                                        onClick={(event) => this.handleMenu(event)}
                                        size="small"
                                        sx={{ml: 2}}
                                        aria-controls={this.state.anchorEl ? 'account-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={this.state.anchorEl ? 'true' : undefined}
                                    >
                                        <Avatar sx={{width: 32, height: 32}}>?</Avatar>
                                    </IconButton>
                                    <Menu
                                        anchorEl={this.state.anchorEl}
                                        id="account-menu"
                                        open={this.state.anchorEl}
                                        onClose={() => this.handleCloseMenu()}
                                        onClick={() => this.handleCloseMenu()}
                                        slotProps={{
                                            paper: {
                                                elevation: 0,
                                                sx: {
                                                    overflow: 'visible',
                                                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                    mt: 1.5,
                                                    '& .MuiAvatar-root': {
                                                        width: 32,
                                                        height: 32,
                                                        ml: -0.5,
                                                        mr: 1,
                                                    },
                                                    '&::before': {
                                                        content: '""',
                                                        display: 'block',
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 14,
                                                        width: 10,
                                                        height: 10,
                                                        bgcolor: 'background.paper',
                                                        transform: 'translateY(-50%) rotate(45deg)',
                                                        zIndex: 0,
                                                    },
                                                },
                                            },
                                        }}
                                        transformOrigin={{horizontal: 'right', vertical: 'top'}}
                                        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                                    >
                                        <MenuItem onClick={() => this.handleCloseMenu()} style={{cursor: 'default'}}>
                                            <strong>Condizioni per generare la spedizione</strong>
                                        </MenuItem>
                                        <Divider/>
                                        <div style={{maxWidth: '400px', padding: '5px'}}>
                                            <p>Per poter generare una spedizione è necessario inserire almeno 3 device
                                                oppure almeno un device con valore superiore a 300 euro</p>
                                        </div>
                                    </Menu>
                                </Box>
                            )}
                        />
                    </Box>
                </Box>
            );
        }

        if (localStorage.getItem("idAffiliato") == 364) {
            listaSpedizioniPending = (
                <Box style={{textAlign: '-webkit-center'}}>
                    <Box className={classes.ResultBox}>
                        <h3 className={classes.FiltriTitle}>
                            SPEDIZIONI IN ATTESA
                        </h3>
                        <MaterialReactTable
                            columns={newColumns}
                            data={this.state.spedizioni}
                            enableRowSelection
                            // enableColumnOrdering
                            enablePinning
                            enableGlobalFilter={true}
                            muiTablePaginationProps={{
                                rowsPerPageOptions: [10, 25, 50, 100]
                            }}
                            // onRowSelectionChange={() => setRowSelection()}
                            initialState={{density: 'compact'}}
                            layoutMode="grid"
                            renderTopToolbarCustomActions={({table}) => (
                                <Box
                                    sx={{display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap'}}
                                >
                                    <Button
                                        color="primary"
                                        clicked={() => handleExportData(table.getSelectedRowModel().rows)}
                                        variant="contained"
                                    >
                                        {'GENERA SPEDIZIONE GLS'}
                                    </Button>
                                    <Button
                                        color="primary"
                                        clicked={() => handleExportDataInterno(table.getSelectedRowModel().rows)}
                                        variant="contained"
                                    >
                                        {'GENERA SPEDIZIONE INTERNA'}
                                    </Button>
                                    <IconButton
                                        onClick={(event) => this.handleMenu(event)}
                                        size="small"
                                        sx={{ml: 2}}
                                        aria-controls={this.state.anchorEl ? 'account-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={this.state.anchorEl ? 'true' : undefined}
                                    >
                                        <Avatar sx={{width: 32, height: 32}}>?</Avatar>
                                    </IconButton>
                                    <Menu
                                        anchorEl={this.state.anchorEl}
                                        id="account-menu"
                                        open={this.state.anchorEl}
                                        onClose={() => this.handleCloseMenu()}
                                        onClick={() => this.handleCloseMenu()}
                                        slotProps={{
                                            paper: {
                                                elevation: 0,
                                                sx: {
                                                    overflow: 'visible',
                                                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                                    mt: 1.5,
                                                    '& .MuiAvatar-root': {
                                                        width: 32,
                                                        height: 32,
                                                        ml: -0.5,
                                                        mr: 1,
                                                    },
                                                    '&::before': {
                                                        content: '""',
                                                        display: 'block',
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 14,
                                                        width: 10,
                                                        height: 10,
                                                        bgcolor: 'background.paper',
                                                        transform: 'translateY(-50%) rotate(45deg)',
                                                        zIndex: 0,
                                                    },
                                                },
                                            },
                                        }}
                                        transformOrigin={{horizontal: 'right', vertical: 'top'}}
                                        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                                    >
                                        <MenuItem onClick={() => this.handleCloseMenu()} style={{cursor: 'default'}}>
                                            <strong>Condizioni per generare la spedizione</strong>
                                        </MenuItem>
                                        <Divider/>
                                        <div style={{maxWidth: '400px', padding: '5px'}}>
                                            <p>Per poter generare una spedizione è necessario inserire almeno 3 device
                                                oppure almeno un device con valore superiore a 300 euro</p>
                                        </div>
                                    </Menu>
                                </Box>
                            )}
                        />
                    </Box>
                </Box>
            );
        }

        return (
            <Auxiliary>
                {confirmAlert}
                {errorAlert}
                {confirmReinvioAlert}
                {confirmSpedizioneConfermata}
                {errorReinvioAlert}
                {schedaCompleta}
                {listaSpedizioniPending}
                {modal}
                {modalConferma}
                <Box style={{textAlign: '-webkit-center'}}>
                    <Box className={classes.ResultBox}>
                        <h3 className={classes.FiltriTitle}>
                            STORICO SPEDIZIONI
                        </h3>
                        {listaStoricoSpedizioni}
                    </Box>
                </Box>
            </Auxiliary>
        );
    }
}



export default (SpedizioniPending);
